import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { List, ListItem, ListItemText, Divider, Select, MenuItem, InputLabel, FormControl, Paper } from '@mui/material'
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { actualizarEvaluacion } from '../../Redux/evaluaciones';
import TokenContext from '../../context/TokenContext';
import { UserAuth } from '../../context/AuthContext';
import * as yup from 'yup'
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import CustomDateField from '../CustomDateField';
import CustomSelect from '../CustomSelect'
import { obtenerEmpleados } from '../../Redux/autocompletados';
import CustomSearchSelect from '../CustomSearchSelect';
import CustomTextField from '../CustomTextField';
import CustomSelectMultiple from '../CustomSelectMultiple';

const ModalPlanificacionUnificada = ({ open, handleClose, asignacion, asignacionId, onSubmit }) => {
    const dispatch = useDispatch()
    const theme = useTheme()
    const token = useContext(TokenContext)
    const { empleado } = UserAuth()
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('lg');

    const [opcionesTeamTeachingInvitado, setOpcionesTeamTeachingInvitado] = React.useState([])
    const teamTeachingInvitadoSelector = useSelector(store => store.autocompletados.empleados)

    const { new_docente, new_materia, new_periodo } = asignacion || {};

    const defaultValues = {
        new_fechadevencimiento: '',
        new_transferenciadeinvestigacion: '',
        new_desarrollodeinvestigacion: '',
        new_extensionpatpic: '',
        new_tipodeextension: '',
        new_teamteachinginvitado: '',
        new_experiencia: '',
        new_didacticas1ernivel: null,
        new_tipodidacticas1ernivel: [],
        new_didcticas2donivel: null,
        new_tipodedidcticas1ernivel: '',
        new_institutos: [],
        new_diferenciales: '',
        new_categoriateorica: '',
        new_innovaciontecnologica: [],
        new_dimension: '',
        new_bibliografabsica: '',
        new_bibliografaampliatoria: ''
    }

    const validacionSchema = yup.object().shape({
        // new_fechadevencimiento: yup.string().required("Required"),
    });

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validacionSchema),
        mode: "onChange",
        shouldFocusError: true
    })

    const { handleSubmit, trigger, setValue, reset } = methods;

    React.useEffect(() => {
        if (token) {
            dispatch(obtenerEmpleados(token))
        }
    }, [token, empleado])

    React.useEffect(() => {
        if (teamTeachingInvitadoSelector?.length > 0) {
            var array = []
            teamTeachingInvitadoSelector.forEach(element => {
                var objeto = {
                    value: element.new_empleadoid,
                    label: element.new_name,
                }
                array.push(objeto)
            });
            setOpcionesTeamTeachingInvitado(array)
        }
    }, [teamTeachingInvitadoSelector])

    const submitDatos = (datos) => {
        onSubmit(datos)
        // reset()
    }
    const opcionesSiNo = [
        { value: false, label: 'No' },
        { value: true, label: 'Si' },
    ]
    const opcionesTipoDeExtension = [
        { value: 100000000, label: 'PAT' },
        { value: 100000001, label: 'PIC' },
    ]

    const opcionesExperiencia = [
        { value: 100000000, label: 'Clase espejo' },
        { value: 100000001, label: 'Conferencias' },
        { value: 100000002, label: 'Feria 21' },
        { value: 100000003, label: 'Indoor Académico (empresa/organización en el aula)' },
        { value: 100000004, label: 'Outdoor Académico (EXPERIMENTA outdoor)' },
        { value: 100000005, label: 'Talks 21 (charlas mas cortas con expertos)' },
        { value: 100000006, label: 'No aplica' },
    ]

    const opcionesInstitutos = [
        { value: '100000000', label: 'Instituto de Derecho Privado y Comparado “Dr. Pedro León”' },
        { value: '100000001', label: 'Instituto de Derecho Público “Arturo M. Bas”' },
        { value: '100000002', label: 'Instituto de Derecho del Trabajo “Dr. Mario L. Devali”' },
        { value: '100000003', label: 'Instituto de Derecho Administrativo “Dr. Pedro Guillermo Altamira”' },
        { value: '100000004', label: 'Instituto de Innovación Educativa' },
        { value: '100000005', label: 'Instituto Cultura de Paz' },
        { value: '100000006', label: 'Instituto de Género e Inclusión' },
        { value: '100000007', label: 'Instituto de Empresa Familiar' },
    ]

    const opcionesDiferenciales = [
        { value: 100000000, label: 'Emprendimiento' },
        { value: 100000001, label: 'Sustentabilidad' },
        { value: 100000002, label: 'Internacionalización' },
    ]

    const opcionesInnovacion = [
        { value: '100000000', label: 'Aula Coco Chanel' },
        { value: '100000001', label: 'Aula Flexible Arcor' },
        { value: '100000002', label: 'Aula MAC' },
        { value: '100000003', label: 'Aula PC' },
        { value: '100000004', label: 'Casco virtual' },
        { value: '100000005', label: 'Co- working' },
        { value: '100000006', label: 'LEGO' },
        { value: '100000007', label: 'Maker' },
        { value: '100000008', label: 'Simuladores' },
        { value: '100000009', label: 'Software' },
    ]

    const opcionesDidacticas1 = [
        { value: 100000000, label: 'Evaluar' },
        { value: 100000001, label: 'Analizar' },
        { value: 100000002, label: 'Aplicar' },
        { value: 100000003, label: 'Comprender' },
        { value: 100000004, label: 'Recordar' },
    ]

    const opcionesDidacticas2 = [
        { value: 100000000, label: 'ABC' },
        { value: 100000001, label: 'ABP' },
        { value: 100000002, label: 'ABR' },
        { value: 100000003, label: 'ABProy' },
    ]

    return (
        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}

        >
            <FormProvider {...methods}>
                <form>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <TextField label="Docente" value={new_docente} fullWidth multiline />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField label="Materia" value={new_materia} fullWidth />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField label="Periodo" value={new_periodo} fullWidth />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid xs={12} sm={6} item sx={{ mt: 2 }}>
                                <CustomDateField
                                    name="new_fechadevencimiento"
                                    label="Fecha de vencimiento"
                                    rules={{ required: 'Required!' }}
                                    helperText="Por favor indica la fecha de vencimiento"
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_transferenciadeinvestigacion"
                                    label="Transferencia de investigación"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesSiNo}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_extensionpatpic"
                                    label="Extensión: PAT/PIC"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesSiNo}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_tipodeextension"
                                    label="Tipo de extensión"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesTipoDeExtension}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_desarrollodeinvestigacion"
                                    label="Desarrollo de investigación"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesSiNo}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            {/* <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_teamteaching"
                                    label="Team Teaching"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesSiNo}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid> */}

                            <Grid xs={12} sm={6} item>
                                <CustomSearchSelect
                                    name="new_teamteachinginvitado"
                                    lab="Team Teaching Invitado"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesTeamTeachingInvitado}
                                    rules={{ required: "Required!" }}
                                    // req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_experiencia"
                                    label="Experiencia"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesExperiencia}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelectMultiple
                                    name="new_institutos"
                                    label="Institutos"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesInstitutos}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_diferenciales"
                                    label="Diferencial"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesDiferenciales}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomTextField
                                    Component={TextField}
                                    name="new_categoriateorica"
                                    label="Categoría teórica"
                                    helperText="Por favor detalla"
                                    multiline
                                    rules={{ required: "Required!" }}
                                    // req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelectMultiple
                                    name="new_innovaciontecnologica"
                                    label="Innovación tecnológica"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesInnovacion}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_didacticas1ernivel"
                                    label="Didácticas 1er nivel"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesSiNo}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelectMultiple
                                    name="new_tipodidacticas1ernivel"
                                    label="Tipo de didácticas 1er nivel"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesDidacticas1}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_didcticas2donivel"
                                    label="Didácticas 2do nivel"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesSiNo}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomSelect
                                    name="new_tipodedidcticas1ernivel"
                                    label="Tipo de didácticas 2do nivel"
                                    helperText="Por favor seleccione un valor"
                                    options={opcionesDidacticas2}
                                    rules={{ required: "Required!" }}
                                    req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomTextField
                                    Component={TextField}
                                    name="new_dimension"
                                    label="Dimensión"
                                    helperText="Por favor detalla"
                                    multiline
                                    rules={{ required: "Required!" }}
                                    // req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomTextField
                                    Component={TextField}
                                    name="new_bibliografabsica"
                                    label="Bibliografía Básica"
                                    helperText="Por favor detalla"
                                    multiline
                                    rules={{ required: "Required!" }}
                                    // req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                            <Grid xs={12} sm={6} item>
                                <CustomTextField
                                    Component={TextField}
                                    name="new_bibliografaampliatoria"
                                    label="Bibliografía ampliatoria"
                                    helperText="Por favor detalla"
                                    multiline
                                    rules={{ required: "Required!" }}
                                    // req={true}
                                    className="custom-helper"
                                />
                            </Grid>

                        </Grid>

                    </DialogContent>
                    <DialogActions>
                        <Box sx={{ p: 2, textAlign: 'right' }}>
                            <Button variant="text" color="secondary" onClick={handleClose}>
                                Cerrar
                            </Button>
                            <Button variant="contained" color="secondary" onClick={handleSubmit(submitDatos)}>
                                Completar
                            </Button>
                        </Box>
                    </DialogActions>
                </form>
            </FormProvider>
        </Dialog>
    )
}

export default ModalPlanificacionUnificada